import { mdiFinance } from '@mdi/js'

export default [
  {
    title: 'مالی',
    icon: mdiFinance,
    action: 'can_see_payments_menu',
    resource: 'all',
    children: [
      {
        title: 'مرجوعی‌های مشروط',
        to: 'financial-conditional-returns',
        action: 'can_cancel_items_of_payment',
        resource: 'all',
      },
      {
        title: 'فاکتور ها',
        to: 'financial-bills',
        action: 'can_see_bills',
        resource: 'all',
      },
      {
        title: 'تراکنش ها',
        to: 'financial-payments',
        action: 'can_see_payments',
        resource: 'all',
      },
      {
        title: 'کارتکس',
        to: 'financial-cortex',
        action: 'can_see_cortex_page',
        resource: 'all',
      },
      {
        title: 'گزارش فروش',
        to: 'financial-sell-report',
        action: 'can_see_sell_report',
        resource: 'all',
      },
      {
        title: 'گزارش فروش درگاه ارزی',
        to: 'financial-sell-report-usd',
        action: 'can_see_sell_report_usd',
        resource: 'all',
      },
      {
        title: 'گزارش موجودی',
        to: 'financial-inventory-report',
        action: 'can_see_inventory_report',
        resource: 'all',
      },
      {
        title: 'گزارش سود',
        to: 'financial-profit-report',
        action: 'can_see_profit_report',
        resource: 'all',
      },
      {
        title: 'گزارش خرید',
        to: 'financial-buy-report',
        action: 'can_see_buy_report',
        resource: 'all',
      },
      {
        title: 'گزارش کد جایگزین',
        to: 'financial-replace-code-report',
        action: 'can_see_replace_report',
        resource: 'all',
      },
      {
        title: 'کارمزد بانک',
        to: 'financial-bank-wage',
        action: 'can_see_and_change_bank_wage_setting',
        resource: 'all',
      },
    ],
  },
]
